const enabled = import.meta.env.VITE_ENV !== 'production';

type DevCommand = { summary: string; run: (...args: unknown[]) => unknown };

const commands = new Map<string, DevCommand>();
const flags = new Map<string, boolean>();
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((fn) => fn());
export const subscribeDevFlag = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getDevFlag = (key: string) => flags.get(key) ?? false;

const setDevFlag = (key: string, value: boolean) => {
  flags.set(key, value);
  emit();
};

const register = (name: string, summary: string, run: (...args: unknown[]) => unknown) => {
  commands.set(name, { summary, run });
  (window as unknown as Record<string, unknown>)[name] = run;
};

// No-op in production so nothing leaks onto `window`.
export const initDevConsole = () => {
  if (!enabled || commands.size > 0) return;

  register('help', 'List available dev console commands', () => {
    const lines = [...commands].map(([name, cmd]) => `  ${name}() — ${cmd.summary}`);

    console.info(['K3X dev console:', ...lines].join('\n'));
  });

  register('aiStream', 'Toggle AI stream + poll logging for the assistant panel', () => {
    const next = !getDevFlag('aiStreamLogs');
    setDevFlag('aiStreamLogs', next);

    console.info(
      next
        ? 'AI stream logs on. Send a prompt and watch [ai-sse] / [ai-poll] lines.'
        : 'AI stream logs off.',
    );
  });

  register('webhook', 'Toggle the webhook payload test form on an agent webhook panel', () => {
    const next = !getDevFlag('webhookTester');
    setDevFlag('webhookTester', next);

    console.info(
      next
        ? 'Webhook tester on. Open an agent with an active webhook to see it.'
        : 'Webhook tester off.',
    );
  });
};
